import errorsMessage from "./errorsMessages"

const errorMapper = (err: string) => {
  return errorsMessage[err]
}

export default errorMapper